module.exports = __webpack_public_path__ + "img/AlessandroEscapamentos.26db30fe.png";